interface TrendMonth {
  month: string;
  health_score: number;
  healthy_count: number;
  unhealthy_count: number;
}

export default function NutritionTrendChart({ months }: { months: TrendMonth[] }) {
  if (months.length === 0) return null;

  const maxScore = 100;
  const barHeight = 120;

  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 8, height: barHeight + 30, padding: "0 4px" }}>
      {months.map((m) => {
        const h = (m.health_score / maxScore) * barHeight;
        const color =
          m.health_score >= 70 ? "var(--xpn-color-success)"
          : m.health_score >= 40 ? "var(--xpn-color-warning)"
          : "var(--xpn-color-danger)";

        const label = m.month.slice(5, 7) + "/" + m.month.slice(2, 4);

        return (
          <div key={m.month} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <span className="xpn-text-caption-tabular xpn-text-muted" style={{ fontSize: 11 }}>
              {m.health_score}
            </span>
            <div
              style={{
                width: "100%",
                height: Math.max(h, 4),
                borderRadius: "4px 4px 0 0",
                background: color,
                transition: "height 0.4s ease",
                minHeight: 4,
              }}
            />
            <span className="xpn-text-caption xpn-text-muted">{label}</span>
          </div>
        );
      })}
    </div>
  );
}
